export enum CheckSourceType {
  issue = 'issue',
  pr = 'pr',
  discussion = 'discussion',
  wiki = 'wiki',
  commit = 'commit',
  tag = 'tag',
  release = 'release',
  milestone = 'milestone',
  cla = 'cla',
}
